import styled from '@emotion/styled';

import Card from 'components/global/Card';
import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const FlexCard = styled(Card)`
	flex-direction: column;
	display: flex;
`;

// Input
export const InputContainer = styled.div`
	width: 100%;
	position: relative;
	margin-bottom: 1.5rem;
	body[dir='rtl'] & {
		text-align: right;
	}
`;

// Expanded Filter
export const ExpandedFilterContainer = styled.div`
	width: 100%;
	display: flex;
	margin-bottom: var(--margin-3);
	transition: all 0.3s;
	&.hide {
		display: none;
	}
	> div {
		min-width: 29rem;
		margin-right: var(--margin-3);
		body[dir='rtl'] & {
			margin-left: var(--margin-3);
			margin-right: 0;
		}
	}

	@media ${Breakpoints.mobile} {
		gap: 1rem;

		> div {
			min-width: unset;
			flex: 1 1 auto;
			margin: unset;
		}
	}
`;
// Content
export const PartnersContainer = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));
	justify-content: flex-start;
	align-content: flex-start;
	max-height: calc(100dvh - 45rem);
	overflow: auto;
	margin-bottom: var(--margin-3);

	@media ${Breakpoints.mobile} {
		grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
	}
`;

// Card
export const ImgContainer = styled.div`
	/* padding: 0 var(--padding-2); */
	display: inline-block;
	position: relative;
	cursor: pointer;
`;
export const StandartPartnerImage = styled(Image)`
	object-fit: contain;
	border-radius: var(--small-border-radius);
	cursor: pointer;
	-webkit-transition: all 0.2s ease;
	transition: all 0.2s ease;

	:hover {
		width: 11rem;
	}
`;

export const LoadingContainer = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));
	justify-content: flex-start;
	align-content: flex-start;
	max-height: calc(100dvh - 45rem);
	overflow: auto;
	@media ${Breakpoints.mobile} {
		grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
	}
	min-height: 400px;
	> div {
		margin: 0 var(--margin-5) var(--margin-3) 0;
		body[dir='rtl'] & {
			margin: 0 0 var(--margin-3) var(--margin-5);
		}
	}
`;
